import { createRenderoni, type RenderoniEngine } from 'renderoni';
import type { EnvironmentDef } from '../config/environments';
import { SIM } from '../config/tuning';
import { Run } from './run';
import { vehicleStats, type VehicleStats } from './upgrades';

export interface Sim {
  engine: RenderoniEngine;
  run: Run;
}

/**
 * Creates a fresh engine and run. The simulation is always headless: the browser game renders with
 * its own Three.js renderer from Renderoni's interpolated transforms. Restarting a run means
 * disposing this Sim and creating a new one, so every run starts from an identical fresh world.
 * `stats` come from the garage (upgrades); they are fixed for the whole run.
 */
export async function createSim(env: EnvironmentDef, stats: VehicleStats = vehicleStats()): Promise<Sim> {
  const engine = await createRenderoni({
    mode: 'headless',
    seed: env.seed,
    gravity: [0, -env.gravity, 0],
    clock: { tickRateHz: SIM.tickRateHz, maxSubSteps: 5 },
  });
  return { engine, run: new Run(engine, env, stats) };
}

export function disposeSim(sim: Sim): void {
  sim.run.dispose();
  sim.engine.dispose();
}
